import { UseQueryStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks.d'
import { createApi } from '@reduxjs/toolkit/query/react'

import { API_VERSION_3, PER_PAGE } from '@store/constants'

import baseQueryInterceptor from '@api/base-query-interceptor'
import { ApiResponse } from '@api/types/api-response.type'

import { Status } from '@adUtilities/constants'

export interface ProjectListDetails {
  id: string
  name: string
  canonicalName: string
  uuid: string
}

export interface Pagination {
  currentPage: number
  lastPage: number
  perPage: number
  total: number
}

export interface ProjectApiResponse {
  data: ProjectListDetails[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

interface ProjectListParams {
  page: number
  query: string
}

interface ProjectListApiResult {
  list: ProjectListDetails[]
  pagination: Pagination
  isLoaded: boolean
  hasError: boolean
  status: string
}

export const projectListApi = createApi({
  reducerPath: 'projectListApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    getProjectList: builder.query<
      ApiResponse<ProjectApiResponse>,
      ProjectListParams
    >({
      query: (params: ProjectListParams) => ({
        url: `/${API_VERSION_3}/projects/list`,
        method: 'get',
        params: {
          page: params.page,
          per_page: PER_PAGE,
          search: params.query,
          status: Status.Available,
        },
      }),
    }),
  }),
})

export const selectFromResult = ({
  status,
  data,
  error,
}: UseQueryStateResult<any, any>): ProjectListApiResult => ({
  list: data?.data?.data || [],
  pagination: {
    currentPage: data?.data?.current_page || 1,
    lastPage: data?.data?.last_page || 1,
    perPage: data?.data?.per_page || 5,
    total: data?.data?.total || 1,
  },
  isLoaded: status === 'fulfilled',
  hasError: error !== undefined,
  status,
})

export const { useGetProjectListQuery, useLazyGetProjectListQuery } =
  projectListApi
